import { gql, TypedDocumentNode } from '@apollo/client';

import { ExchangeModeEnum, RateTypeEnum } from '@libs/backend-common';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
export type GetExchangeFeesWithRangesData = {
  greaterThan: number;
  buyRate: number;
  isActive: boolean;
  rateType: RateTypeEnum;
  sellRate: number;
  id: string;
};
export type GetExchangeFeesWithRangesRes = {
  data: GetExchangeFeesWithRangesData[];
  userVolume?: string;
  minAmountInGel?: number;
  minAmountInUsd?: number;
  currentFee?: {
    buyRate: number;
  };
};
export type GetExchangeFeesWithRangesResponse = {
  getExchangeFeesWithRanges: DefaultApiResponse<GetExchangeFeesWithRangesRes>;
};

export const getExchangeFeesWithRangesQuery: TypedDocumentNode<
  GetExchangeFeesWithRangesResponse,
  DefaultArg<{ valueAssetCode: string; mode: ExchangeModeEnum }>
> = gql`
  query GetExchangeFeesWithRanges($record: GetExchangeFeesWithRangesRecord!) {
    getExchangeFeesWithRanges(record: $record) {
      data {
        greaterThan
        buyRate
        isActive
        rateType
        id
        sellRate
      }
      currentFee {
        buyRate
      }
      userVolume
      minAmountInGel
      minAmountInUsd
    }
  }
`;
